import { render, staticRenderFns } from "./BankStatements.vue?vue&type=template&id=e364cb46&scoped=true&"
import script from "./BankStatements.vue?vue&type=script&lang=js&"
export * from "./BankStatements.vue?vue&type=script&lang=js&"
import style0 from "./BankStatements.vue?vue&type=style&index=0&id=e364cb46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e364cb46",
  null
  
)

export default component.exports